// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UXiG","colMin":"styles_colMin__1vTyh"};